import { useEffect, useState } from "react";
import CommonModal from "../modalLayout/CommonModal";
import FileUploadBox from "../fileUpload/FileUploadBox";
import { PRESCRIPTION_UPLOAD_ACCEPT } from "../../../helpers/prescriptionFormat";

const UploadVaDocumentModal = ({
  show,
  setShow,
  title = "Upload file",
  onSave,
  confirmLoading = false,
}) => {
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (!show) return;
    setFile(null);
  }, [show]);

  const handleConfirm = async () => {
    if (!(file instanceof File)) return;
    await onSave?.(file);
  };

  const handleDiscard = () => {
    setFile(null);
    setShow?.(false);
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title={title}
      centered
      onConfirm={handleConfirm}
      onCancel={handleDiscard}
      onHide={handleDiscard}
      confirmLabel="Confirm"
      confirmLoading={confirmLoading}
      confirmDisabled={!(file instanceof File)}
    >
      <FileUploadBox
        key={show ? "open" : "closed"}
        setUploadedFile={setFile}
        acceptedFormats={PRESCRIPTION_UPLOAD_ACCEPT}
        maxSize={10}
        label="Click to upload or drag and drop"
        subLabel="PDF, PNG, or JPEG (max 10MB)"
      />
    </CommonModal>
  );
};

export default UploadVaDocumentModal;
